import React, { FC } from 'react';
import QuestionIcon from '@atlaskit/icon/glyph/question-circle';
import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import { css } from '@emotion/core';

import { SPACE_MINIMUM } from '@/styles';

type DiscoveryButtonProps = {
  testId?: string;
  url: string;
};

const iconStyles = css`
  margin-left: ${SPACE_MINIMUM}px;
`;
const fontStyles = css`
  font-size: 0.9em;
  margin: ${SPACE_MINIMUM}px;
  color: ${token('color.icon')};
`;

const DiscoveryButton: FC<DiscoveryButtonProps> = ({ testId = '', url }) => (
  <Button
    iconBefore={
      <span css={iconStyles}>
        <QuestionIcon primaryColor={token('color.icon')} label="See more icon" size="small" />
      </span>
    }
    appearance="subtle"
    spacing="none"
    href={url}
    testId={testId}
  >
    <span css={fontStyles}>See our docs</span>
  </Button>
);

export default DiscoveryButton;
